export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
    "reels_atlas": [imgsPath + "reels/reels_atlas_{q}.png", imgsPath + "reels/reels_atlas_{q}.json"],

    //"symbols_atlas": [imgsPath + "symbols/symbols_atlas_{q}.png", imgsPath + "symbols/symbols_atlas_{q}.json"],
    //"symbols_blur_atlas": [imgsPath + "symbols/symbols_blur_atlas_{q}.png", imgsPath + "symbols/symbols_blur_atlas_{q}.json"],
    "symbols_all_atlas": [imgsPath + "symbols/symbols_all_atlas_{q}.png", imgsPath + "symbols/symbols_all_atlas_{q}.json"],

    /*"sea_reels_menu_atlas_0": [imgsPath + "reels/sea_reels_menu_atlas_0_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_0_{q}.json"],
    "sea_reels_menu_atlas_1": [imgsPath + "reels/sea_reels_menu_atlas_1_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_1_{q}.json"],
    "sea_reels_menu_atlas_2": [imgsPath + "reels/sea_reels_menu_atlas_2_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_2_{q}.json"],
    "sea_reels_menu_atlas_3": [imgsPath + "reels/sea_reels_menu_atlas_3_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_3_{q}.json"],
    "sea_reels_menu_atlas_4": [imgsPath + "reels/sea_reels_menu_atlas_4_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_4_{q}.json"],
    "sea_reels_menu_atlas_5": [imgsPath + "reels/sea_reels_menu_atlas_5_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_5_{q}.json"],
    /*"sea_reels_menu_atlas_6": [imgsPath + "reels/sea_reels_menu_atlas_6_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_6_{q}.json"],
    "sea_reels_menu_atlas_7": [imgsPath + "reels/sea_reels_menu_atlas_7_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_7_{q}.json"],
    "sea_reels_menu_atlas_8": [imgsPath + "reels/sea_reels_menu_atlas_8_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_8_{q}.json"],
    "sea_reels_menu_atlas_9": [imgsPath + "reels/sea_reels_menu_atlas_9_{q}.png", imgsPath + "reels/sea_reels_menu_atlas_9_{q}.json"],*/

    "sea_reels_menu_atlas": [imgsPath + "reels/sea/sea_reels_menu_full_atlas_{q}.png", imgsPath + "reels/sea/sea_reels_menu_full_atlas_{q}.json"],
//	"cloud_atlas": [imgsPath + "reels/cloud_atlas_{q}.png", imgsPath + "reels/cloud_atlas_{q}.json"],

    "symbol_J_atlas": [imgsPath + "symbols/symbol_J/symbol_J_atlas_{q}.png", imgsPath + "symbols/symbol_J/symbol_J_atlas_{q}.json"],
    "symbol_Q_atlas": [imgsPath + "symbols/symbol_Q/symbol_Q_atlas_{q}.png", imgsPath + "symbols/symbol_Q/symbol_Q_atlas_{q}.json"],
    "symbol_K_atlas": [imgsPath + "symbols/symbol_K/symbol_K_atlas_{q}.png", imgsPath + "symbols/symbol_K/symbol_K_atlas_{q}.json"],
    "symbol_A_atlas": [imgsPath + "symbols/symbol_A/symbol_A_atlas_{q}.png", imgsPath + "symbols/symbol_A/symbol_A_atlas_{q}.json"],
    "symbol_Bracelet_atlas": [imgsPath + "symbols/symbol_Bracelet/symbol_Bracelet_atlas_{q}.png", imgsPath + "symbols/symbol_Bracelet/symbol_Bracelet_atlas_{q}.json"],
    "symbol_Shield_atlas": [imgsPath + "symbols/symbol_Shield/symbol_Shield_atlas_{q}.png", imgsPath + "symbols/symbol_Shield/symbol_Shield_atlas_{q}.json"],
    "symbol_Axe_atlas": [imgsPath + "symbols/symbol_Axe/symbol_Axe_atlas_{q}.png", imgsPath + "symbols/symbol_Axe/symbol_Axe_atlas_{q}.json"],
    "symbol_Helmet_atlas": [imgsPath + "symbols/symbol_Helmet/symbol_Helmet_atlas_{q}.png", imgsPath + "symbols/symbol_Helmet/symbol_Helmet_atlas_{q}.json"],
    "symbol_Woman_atlas": [imgsPath + "symbols/symbol_Woman/symbol_Woman_atlas_{q}.png", imgsPath + "symbols/symbol_Woman/symbol_Woman_atlas_{q}.json"],
    "symbol_Viking_atlas": [imgsPath + "symbols/symbol_Viking/symbol_Viking_atlas_{q}.png", imgsPath + "symbols/symbol_Viking/symbol_Viking_atlas_{q}.json"],
    "symbol_Wild_atlas": [imgsPath + "symbols/symbol_Wild/symbol_Wild_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_atlas_{q}.json"],
    "symbol_Scatter_atlas": [imgsPath + "symbols/symbol_Scatter/symbol_Scatter_atlas_{q}.png", imgsPath + "symbols/symbol_Scatter/symbol_Scatter_atlas_{q}.json"],

    "bw_fire_atlas": [imgsPath + "bigwin/bw_fire_atlas_{q}.png", imgsPath + "bigwin/bw_fire_atlas_{q}.json"],
    "fire_background_atlas": [imgsPath + "symbols/fire_background_atlas_{q}.png", imgsPath + "symbols/fire_background_atlas_{q}.json"],
    "fire_ring_atlas": [imgsPath + "symbols/fire_ring_atlas_{q}.png", imgsPath + "symbols/fire_ring_atlas_{q}.json"],
    "fire_ring_loop_atlas": [imgsPath + "symbols/fire_ring_loop_atlas_{q}.png", imgsPath + "symbols/fire_ring_loop_atlas_{q}.json"],
    "arrow_atlas": [imgsPath + "symbols/arrow_atlas_{q}.png", imgsPath + "symbols/arrow_atlas_{q}.json"],

    //"logo_atlas": [imgsPath + "reels/logo_atlas_{q}.png", imgsPath + "reels/logo_atlas_{q}.json"],

    "bigwin_table_atlas": [imgsPath + "bigwin/bw_table_atlas_{q}.png", imgsPath + "bigwin/bw_table_atlas_{q}.json"],

    "fire_fs_atlas": [imgsPath + "freespins/fire_fs_atlas_{q}.png", imgsPath + "freespins/fire_fs_atlas_{q}.json"],
    "fire_fs_bg_atlas": [imgsPath + "freespins/fire_fs_bg_atlas_{q}.png", imgsPath + "freespins/fire_fs_bg_atlas_{q}.json"],
    "fire_rope_atlas": [imgsPath + "freespins/fire_rope_atlas_{q}.png", imgsPath + "freespins/fire_rope_atlas_{q}.json"],

//	"cover_rope_atlas": [imgsPath + "reels/cover/rope_atlas_{q}.png", imgsPath + "reels/cover/rope_atlas_{q}.json"],

    "info_symbols_atlas": [imgsPath + "info/info_symbols_atlas_{q}.png", imgsPath + "info/info_symbols_atlas_{q}.json"],

    "multi_atlas": [imgsPath + "multiplier/multi_atlas_{q}.png", imgsPath + "multiplier/multi_atlas_{q}.json"],

    "preinfo_atlas": [imgsPath + "preinfo/preinfo_atlas_{q}.png", imgsPath + "preinfo/preinfo_atlas_{q}.json"]
};

export const to_load = {
    // 'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    // 'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "background": imgsPath + "reels/background_{q}.jpg",
    "win_background": imgsPath + "reels/win_background_{q}.png",

    "shine_woman": imgsPath + "symbols/shine_woman_{q}.png",
    "shine_wild": imgsPath + "symbols/shine_wild_{q}.png",
    "shine_viking": imgsPath + "symbols/shine_viking_{q}.png",
    "shine_scatter": imgsPath + "symbols/shine_ship_{q}.png",

    "bigwin": imgsPath + "bigwin/bigwin_{q}.png",
    "megawin":imgsPath + "bigwin/megawin_{q}.png",
    "supermegawin":imgsPath + "bigwin/supermegawin_{q}.png",
    //"bigwin_table": imgsPath + "bigwin/bigwin_table_{q}.png",
    "bigwin_light": imgsPath + "bigwin/light_{q}.png",

    "freespinswin": imgsPath + "freespins/win_text_{q}.png",
    "fs_text": imgsPath + "freespins/text_{q}.png",
    "fs_bg": imgsPath + "freespins/free-spins_background_{q}.png",

    "storm_01": imgsPath + "reels/storm/storm_01_{q}.png",
    "storm_02": imgsPath + "reels/storm/storm_02_{q}.png",
    "storm_03": imgsPath + "reels/storm/storm_03_{q}.png",
    //"storm_04": imgsPath + "reels/storm/storm_04_{q}.png",
    //"storm_05": imgsPath + "reels/storm/storm_05_{q}.png",
    "storm_06": imgsPath + "reels/storm/storm_06_{q}.png",

    "info_background": imgsPath + "info/background_{q}.png",
    "wintable_1": imgsPath + "info/wintable_1_{q}.png",
    "wintable_2": imgsPath + "info/wintable_2_{q}.png",
    //"wintable_3": imgsPath + "info/wintable_3_{q}.png",
    "10x_free_spins": imgsPath + "info/10x_free_spins_{q}.png",
    "10x_free_spins_es": imgsPath + "info/10x_free_spins_es_{q}.png",
    "winlines": imgsPath + "info/winlines_{q}.png",

    "storm_light": imgsPath + "reels/storm/storm_lighting_{q}.png"
};

var audioType = "ogg";

export const to_load_audio = {
    "bg_Ambient": audioPath + "bg_Ambient." + audioType,
    "bg_Music": audioPath + "bg_Music." + audioType,

    "reel_Start_1": audioPath + "reel_Start_1." + audioType,
    "reel_Start_2": audioPath + "reel_Start_2." + audioType,
    "reel_Start_3": audioPath + "reel_Start_3." + audioType,
    "reel_Stop": audioPath + "reel_Stop." + audioType,

    "win_Axe": audioPath + "win_Axe." + audioType,
    "win_Bracelet": audioPath + "win_Bracelet." + audioType,
    "win_Helmet": audioPath + "win_Helmet." + audioType,
    "win_Letter": audioPath + "win_Letter." + audioType,
    "win_Shield": audioPath + "win_Shield." + audioType,
    "win_Ship": audioPath + "win_Ship." + audioType,
    "win_Viking": audioPath + "win_Viking." + audioType,
    "win_Woman": audioPath + "win_Woman." + audioType,

    "win_Multiplier_Axe": audioPath + "win_Multiplier_Axe." + audioType,
    "win_Multiplier_Bracelet": audioPath + "win_Multiplier_Bracelet." + audioType,
    "win_Multiplier_Helmet": audioPath + "win_Multiplier_Helmet." + audioType,
    "win_Multiplier_Letter": audioPath + "win_Multiplier_Letter." + audioType,
    "win_Multiplier_Shield": audioPath + "win_Multiplier_Shield." + audioType,
    "win_Multiplier_Viking": audioPath + "win_Multiplier_Viking." + audioType,
    "win_Multiplier_Woman": audioPath + "win_Multiplier_Woman." + audioType,

    "symbol_Ship_1": audioPath + "symbol_Ship_1." + audioType,
    "symbol_Ship_2": audioPath + "symbol_Ship_2." + audioType,
    "symbol_Ship_3": audioPath + "symbol_Ship_3." + audioType,

    "reel_Search_Long": audioPath + "reel_Search_Long." + audioType,
    "reel_Search_Short": audioPath + "reel_Search_Short." + audioType,

    "bonus_FreeSpins_In": audioPath + "bonus_FreeSpins_In." + audioType,
    "bonus_FreeSpins_Counter": audioPath + "bonus_FreeSpins_Counter." + audioType,
    "bonus_Arrow_1": audioPath + "bonus_Arrow_1." + audioType,
    "bonus_Arrow_2": audioPath + "bonus_Arrow_2." + audioType,
    "bonus_Lock_Fire": audioPath + "bonus_Lock_Fire." + audioType,

    "bg_FreeSpins_Loop": audioPath + "bg_FreeSpins_Loop." + audioType,
    "bg_FreeSpins_Start": audioPath + "bg_FreeSpins_Start." + audioType,

    "bwin_BigWin": audioPath + "bwin_BigWin." + audioType,
    "bwin_FreeSpins": audioPath + "bwin_FreeSpins." + audioType,
    "bwin_BigWin_Counter": audioPath + "bwin_BigWin_Counter." + audioType,
    "bwin_BigWin_Thunder": audioPath + "bwin_BigWin_Thunder." + audioType,
    "bwin_Money": audioPath + "bwin_Money." + audioType,
    "bwin_Money_Short": audioPath + "bwin_Money_Short." + audioType,
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

(function() {
    for(let i = 1; i <= 5; i++) {
        to_load_audio["misc_Coin_Drop_" + i] = audioPath + "misc_Coin_Drop_" + i + "." + audioType;
    }
}());

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    /*'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },*/

    'font_normal_win': { 'img': imgsPath + 'fonts/font_win-export.png', 'xml': imgsPath + 'fonts/font_win-export.xml' },
    'font_wintable': { 'img': imgsPath + 'fonts/font_wintable.png', 'xml': imgsPath + 'fonts/font_wintable.xml' },
    'font_free_spins': { 'img': imgsPath + 'fonts/font_free_spins.png', 'xml': imgsPath + 'fonts/font_free_spins.xml' }

};

// var to_load_spritesheets = {
//     //"wild_random_shine_sheet": { "url": imgsPath + "symbols/wild/wild_random_appear_shine_sheet_{q}.png", "w": 207, "h": 207 }
// };

export function set_sounds(server_config)
{
}